// STUDIO-PC-QUICKADD-SLIDE-SYNC-1 · 지난 상품 슬라이드 ↔ TEST 공유 세션(past_slide) 양방향 동기화.
// 마지막으로 조작한 기기(owner)만 자동 넘김을 실행하고, 다른 기기는 공유된 순번을 따라 표시한다.
import { useEffect, useRef, useState } from 'react';

const _snap = (s) => (s ? JSON.stringify({ mode: s.mode, playing: !!s.playing, index: s.index || 0, interval: s.interval, effect: s.effect }) : null);

export default function usePastSlideSync({ enabled, ready, ctx, setCtx, local, apply, onTakeover }) {
  const me = useRef(`d_${Math.random().toString(36).slice(2, 10)}`).current;
  const [owner, setOwner] = useState(me);
  const justApplied = useRef(false);
  const remote = ctx?.past_slide || null;
  const remoteSnap = _snap(remote);
  const snap = _snap(local);

  useEffect(() => {
    if (!enabled || !remote || remoteSnap === snap || remote.owner === me) return;
    justApplied.current = true;
    setOwner(remote.owner);
    apply(JSON.parse(remoteSnap));
  }, [enabled, remoteSnap]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (justApplied.current) { justApplied.current = false; return; }
    if (!enabled || !ready || snap === remoteSnap) return;
    setOwner(me);
    setCtx((c) => (c ? { ...c, past_slide: { ...JSON.parse(snap), owner: me, updated_at: new Date().toISOString() } } : c));
  }, [enabled, ready, snap]); // eslint-disable-line react-hooks/exhaustive-deps

  // 주도 기기가 새로고침·종료되어 갱신이 멈추면(간격 + 5초) 이 기기가 자동 넘김을 이어받음.
  const stale = useRef(remote);
  stale.current = remote;
  useEffect(() => {
    if (!enabled || owner === me) return undefined;
    const t = setInterval(() => {
      const r = stale.current;
      const at = Date.parse(r?.updated_at || '');
      if (r?.playing && r.mode !== 'off' && (!at || Date.now() - at > (r.interval || 8) * 1000 + 3000)) { setOwner(me); onTakeover?.(); }
    }, 2000);
    return () => clearInterval(t);
  }, [enabled, owner, me]); // eslint-disable-line react-hooks/exhaustive-deps

  return { leader: !enabled || owner === me };
}
